import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import avatar from '../../Pics/avatar.jpg'

import SpecificComponent from '../SpecificComponent'
import { Fab, FormControl, InputLabel, Select, MenuItem, Input, Grid, Checkbox } from '@material-ui/core';
import Utils from '../../providers/Utils';
import PropTypes from 'prop-types';
import Ws from '../../providers/Ws';
import OpenAddFisaPostului from './OpenAddFisaPostului';
import OpenAddCV from './OpenAddCV';
import AlertDialog from './AlertDialog';


export default class UpdateAngajatDetails extends SpecificComponent {

    constructor(props) {
        super(props)
        this.state = {
            isOpenFisa: false,
            isOpenCv: false,
            isOpenAlert: false,
            strAlertMesaj: ''
        }
    }

    //fisaPost adresaMedia + /Angajati/FisePost

    selectFile = (id) => {

        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()

    }

    uploadFisaPostului = async (id, idAngajat) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);





        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/FisaPostuluiAngajat', saveFile, idAngajat);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.props.getOrganigrama(this.props.angajat)
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }

    uploadCV = async (id, idAngajat) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);





        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/CvAngajat', saveFile, idAngajat);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.props.getOrganigrama(this.props.angajat)

            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }

    openFisaPostului = () => {


        if (this.props.angajat.doc_fisa_postului) {
            let adresaFisa = new Ws().adresaMedia + `/Angajati/FisePost/${this.props.angajat.doc_fisa_postului}`

            window.open(adresaFisa)
        } else {
            this.setState({
                isOpenAlert: true,
                strAlertMesaj: 'Nu exista fisa postului !'
            })
        }

    }


    openCv = () => {

        if (this.props.angajat.cv) {
            let adresaFisa = new Ws().adresaMedia + `/Angajati/Cv/${this.props.angajat.cv}`

            window.open(adresaFisa)
        } else {
            this.setState({
                isOpenAlert: true,
                strAlertMesaj: 'Nu exista CV !'
            })
        }

    }

    openFisa = () => {

        this.setState({
            isOpenFisa: true
        })

    }



    render() {
        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    fullWidth={true}
                    maxWidth={'md'}
                    style={{
                        zIndex: 5000,
                    }}
                >

                    <DialogActions>
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>clear</i>
                        </Fab>
                    </DialogActions>
                    <div className='fix-line'></div>
                    <div
                        className='pm-fisa-postului-container'


                    >

                        <div
                            onClick={() => { this.setState({ isOpenCv: true }) }}
                            //  onClick={()=>{this.selectFile('fisa-postului-file')}} 
                            className='pm-fisa-buttons'>
                            <span>{this.props.limba.organigrama.cv} </span>
                            <i className='material-icons' style={{
                                verticalAlign: 'bottom',
                                color: '#d8a817'
                            }}>book</i>
                        </div>

                        <div
                            onClick={this.openFisa} style={{ marginLeft: 10 }} className='pm-fisa-buttons'>
                            <span>{this.props.limba.organigrama.fisa} </span>
                            <i className='material-icons' style={{
                                verticalAlign: 'bottom',
                                color: '#d8a817'
                            }}>description</i>
                        </div>

                        <div
                            onClick={this.props.openProgram} style={{ marginLeft: 10 }} className='pm-fisa-buttons'>
                            <span>{this.props.limba.organigrama.programLucru} </span>
                            <i className='material-icons' style={{
                                verticalAlign: 'bottom',
                                color: '#d8a817'
                            }}>timelapse</i>
                        </div>



                    </div>

                    <div
                        id={'angajat-upload-poza'}
                        onClick={() => { this.props.selectFile(`file${this.props.angajat.id}`) }}
                        className='pm-angajati-picture-update'
                        style={{
                            backgroundImage: `url('${this.props.angajat.poza ? (new Ws().adresaMedia + '/Angajati/' + this.props.angajat.poza) : avatar}')`,
                        }}>

                    </div>



                    <input type='file' id={`fisa-postului-file`}
                        style={{ display: 'none' }}
                        accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                        onChange={() => { this.uploadFisaPostului('fisa-postului-file', this.props.angajat.id) }} />

                    <input type='file' id={`CV-file`}
                        style={{ display: 'none' }}
                        accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                        onChange={() => { this.uploadCV('CV-file', this.props.angajat.id) }} />

                    <h2 style={{ marginBottom: 5 }} className="pm-title">{this.props.angajat.nume}</h2>
                    <div style={{ textAlign: 'center' }}>

                        <Checkbox style={{ color: '#000000', padding: 2 }}
                            onChange={(ev) => { this.props.esteSef(this.props.angajat, ev, this.props.departament) }}
                            checked={this.props.angajat.sef_departament === 1 ? true : false} />
                        <span style={{ fontWeight: 600, color: '#b7b7b7' }}>{this.props.limba.organigrama.sef}</span>
                    </div>


                    <DialogContent style={{ width: '90%', margin: 'auto', overflow: 'hidden' }}>
                        <Grid style={{ width: '90%', margin: 'auto' }} container >
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >


                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.organigrama.nume}
                                    value={this.props.angajat.nume || ''}
                                    onChange={this.props.changeNume}
                                    margin="normal"
                                />
                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.organigrama.telefon}
                                    value={this.props.angajat.telefon || ''}
                                    onChange={this.props.changeTelefon}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.organigrama.email}
                                    value={this.props.angajat.email || ''}
                                    onChange={this.props.changeEmail}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={'CNP'}
                                    value={this.props.angajat.cnp || ''}
                                    onChange={this.props.changeCnp}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>



                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.organigrama.adresa}
                                    value={this.props.angajat.adresa || ''}
                                    onChange={this.props.changeAdresa}
                                    margin="normal"
                                    multiline
                                />
                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.organigrama.oras}
                                    value={this.props.angajat.oras || ''}
                                    onChange={this.props.changeOras}
                                    margin="normal"
                                    type='text'
                                />

                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >

                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '80%' }}
                                    type="number"
                                    label={'Salariul Brut'}
                                    value={this.props.angajat.salariu_brut || ''}
                                    onChange={this.props.changeSalariu}
                                    margin="normal"
                                    multiline
                                />

                                <FormControl className='inputFocus' style={{ width: '15%', marginTop: 16 }}>
                                    <InputLabel htmlFor="resursa">{this.props.angajat.tip_moneda || 'Lei'}</InputLabel>
                                    <Select

                                        value={this.props.angajat.tip_moneda || ""}
                                        onChange={this.props.changeMoneda}

                                        input={<Input id="resursa" />}>


                                        {this.props.tipuriMoneda.map((s, idx) => {

                                            // console.log('this.props.cote_tva :', s);
                                            return (<MenuItem value={s.id} key={idx}  > {s.nume}</MenuItem>)

                                        })
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >

                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    type="text"
                                    label={"Functia"}
                                    value={this.props.angajat.functie || ''}
                                    onChange={this.props.changeFunctia}
                                    margin="normal"
                                    multiline
                                />
                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '80%' }}
                                    label={this.props.limba.organigrama.cost}
                                    value={this.props.angajat.cost_minut || ''}
                                    onChange={this.props.changeCost}
                                    margin="normal"
                                    type='number'
                                />

                                <FormControl className='inputFocus' style={{ width: '15%', marginTop: 16 }}>
                                    <InputLabel htmlFor="resursa">{this.props.angajat.tip_moneda || 'Lei'}</InputLabel>
                                    <Select

                                        value={this.props.angajat.tip_moneda || ""}
                                        onChange={this.props.changeMoneda}

                                        input={<Input id="resursa" />}>


                                        {this.props.tipuriMoneda.map((s, idx) => {

                                            // console.log('this.props.cote_tva :', s);
                                            return (<MenuItem value={s.id} key={idx}  > {s.nume}</MenuItem>)

                                        })
                                        }
                                    </Select>
                                </FormControl>

                            </Grid>


                        </Grid>

                    </DialogContent>

                    <DialogActions>


                        <Button style={{ margin: 'auto' }} variant="outlined" onClick={() => { this.props.updateAngajat(this.props.angajat) }} className='pm-save-button'>
                            {this.props.limba.comune.save}
                        </Button>
                    </DialogActions>

                </Dialog>



                <OpenAddFisaPostului
                    open={this.state.isOpenFisa}
                    dialogClose={() => { this.setState({ isOpenFisa: false }) }}
                    selectFile={this.selectFile}
                    openFisaPostului={this.openFisaPostului}
                    limba={this.props.limba}
                />



                <OpenAddCV
                    open={this.state.isOpenCv}
                    dialogClose={() => { this.setState({ isOpenCv: false }) }}
                    selectFile={this.selectFile}
                    openCV={this.openCv}
                    limba={this.props.limba}
                />


                <AlertDialog
                    open={this.state.isOpenAlert}
                    dialogClose={() => { this.setState({ isOpenAlert: false }) }}
                    title={this.state.strAlertMesaj}
                    yesFunction={() => { this.setState({ isOpenAlert: false }) }}
                    noButtonDisplay={1}
                    limba={this.props.limba}
                />


            </div>

        );
    }


}  // end class

UpdateAngajatDetails.propTypes = {
    getOrganigrama: PropTypes.func,
    angajat: PropTypes.object,
    open: PropTypes.bool,
    dialogClose: PropTypes.func,
    limba: PropTypes.object,
    openProgram: PropTypes.func,
    departament: PropTypes.object,
    changeNume: PropTypes.func,
    changeTelefon: PropTypes.func,
    changeEmail: PropTypes.func,
    changeAdresa: PropTypes.func,
    changeOras: PropTypes.func,
    changeCost: PropTypes.func,
    changeMoneda: PropTypes.func,
    tipuriMoneda: PropTypes.array,
    updateAngajat: PropTypes.func,




}